import { createStyles, makeStyles } from '@material-ui/core/styles';

import { colors } from '../../styles';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    additional: {
      display: 'flex',
      flexDirection: 'column',
      padding: '0 0 0 20px',
    },
    additionalText: {
      marginLeft: '10px',
      fontSize: '1.1em',
      fontWeight: 'bold',
    },
    counterView: {
      borderRadius: '2px',
      display: 'block',
      height: '100%',
      margin: '1vh 2vw',
      width: '70%',
    },
    counterWrapper: {
      border: '2px solid',
      borderRadius: '3px',
      display: 'flex',
      flex: 1,
      [theme.breakpoints.down('768')]: {
        flex: 1,
      },
    },
    fontTitle: {
      fontFamily: 'Montserrat',
      fontSize: '0.9em',
      fontWeight: 'bold',
      lineHeight: '9px',
      textTransform: 'uppercase',
      color: 'black',
    },
    iconArrow: {
      marginLeft: '5px',
    },
    image: {
      filter: 'brightness(1) contrast(300%) invert(1)',
      height: '45%',
      margin: '1vh 0.8vw',
      width: 'auto',
    },
    icon: {
      height: '100%',
      width: 'auto',
    },
    imageView: {
      alignItems: 'center',
      flex: 0.5,
      flexDirection: 'row',
      height: '96px',
      justifyContent: 'center',
      padding: '1vh 0',
    },
    infoView: {
      alignItems: 'flex-start',
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      justifyContent: 'center',
    },
    titles: {
      textTransform: 'uppercase',
      fontFamily: 'Montserrat',
      fontWeight: 'bold',
    },
    typography: {
      color: 'white',
      fontWeight: 500,
      textAlign: 'center',
      width: '100%',
    },
    values: {
      alignSelf: 'center',
      color: colors.textGrey3e,
      fontSize: '3em',
      fontWeight: 'bold',
      [theme.breakpoints.down('md')]: {
        fontSize: '3em',
      },
    },
    numberValueHolder: {},
    outOf: {
      marginLeft: '7px',
    },
  })
);
